import { router } from 'expo-router'

export const changeSearchProduct = (searchProduct: string): void =>
    router.setParams({ searchProduct })
